import React from "react";

function CrossIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="none"
      viewBox="0 0 10 10"
    >
      <path
        fill="currentColor"
        d="M8.023 9.754a.549.549 0 01-.399.164c-.164 0-.304-.047-.398-.164L4.952 7.481 2.68 9.754a.549.549 0 01-.398.164c-.165 0-.305-.047-.399-.164L.616 8.488C.5 8.395.452 8.254.452 8.09c0-.14.047-.281.164-.398L2.89 5.418.616 3.145C.5 3.05.452 2.91.452 2.746c0-.14.047-.281.164-.398l1.266-1.266a.565.565 0 01.399-.164c.14 0 .28.07.398.164l2.273 2.274 2.274-2.274a.565.565 0 01.398-.164c.14 0 .282.07.399.164l1.265 1.266a.665.665 0 01.164.398c0 .164-.07.305-.164.399L7.015 5.418l2.273 2.274a.665.665 0 01.164.398c0 .164-.07.305-.164.398L8.023 9.754z"
      ></path>
    </svg>
  );
}

export default CrossIcon;
